import list from './list'
import icon from '@material-ui/icons/Person'

export default { list, icon, options: { label: 'External news' } }
